<script>
import modal from "@/components/modal";
import store from "../../store/index.js";
import { isAutohomeApp, getCookie } from '@/common/util';
import returnReco from './returnBlockReco.vue';
import statement from "../statement";
import labelInput from '../returnBlockInput';
import {alertMessage} from '@/lib/ui';
import {reduce} from 'lodash';

export default {
  data() {
    return {
      mainSeries: store.carSeries.series.list[0],
      mobileConf: {
          id: 'mobile',
          maxLength: 11,
          placeholder: '请输入手机号',
          errMsg: '请输入正确格式的手机号',
          eye: false,
          tips: false,
          verify: {
              change(val) {
                  return /^1\d{10}$/.test(val);
              },
              input(val) {
                  return /^\d{1,11}$/.test(val);
              }
          }
      },
      inputCookie: ''
    };
  },
  methods: {
    show() {
      this.returnBlockShow = true;
      this.$nextTick(() => {
        this.addMointor();
      });
    },
    hide() {
      this.returnBlockShow= false;
    },
    checkInputVisiblity() {
      this.inputCookie = getCookie('telphone');
    },
    check() {
        const mobileError = this.$refs.mobile.checkChange();
        return mobileError;
    },
    async submit() {
        let _this = this;
        let labelInput = this.$refs.mobile;
        if (labelInput) {
          const isError = this.check();
          if (isError) {
              return;
          }
        }
        let alert = alertMessage('查询信息提交中…');
        this.$clickMonitor.send({
          buttonId: `return-block-button-click`,
          ...store.getClickMonitorParams()
        });
        const result = await store.submit('return_block_submit_click');
        alert.style.display = 'none';
        if (!result.status) {
            alertMessage(result.msg);
            return;
        }
        let arr = _this.returnBlockArr;
        for (var i=0; i<arr.length; i++) {
            if (arr[i].checked) {
                let recResult = await store.submit('return_block_recommend', arr[i]);
                if (!recResult.status) {
                    alertMessage(recResult.msg);
                    return;
                }
            }
        }
        _this.mobile='';
        _this.$emit('showSuccess', 4);
    },
    format(_price, decimals = 0) {
        if (!_price) {
            return '**';
        }
        let price = _price / 10000 + '';
        if (decimals > 0) {
            const arr = price.split('.');
            const length = arr[1] ? arr[1].length : 0;
            let complement = decimals - length;
            while (complement) {
                if (complement < 0) {
                    arr[1] = arr[1].replace(arr[1].charAt(arr[1].length - 1), '');
                    complement++;
                    continue;
                } else {
                    if (!arr[1]) {
                        arr[1] = '0';
                    } else {
                        arr[1] += '0';
                    }
                }
                complement--;
            }
            price = arr.join('.');
        }
        return price;
    },
    hidden(_price) {
        let arr = _price.split('.');
        if (arr[0].length > 1) {
            // arr[0] = arr[0].replace(arr[0].charAt(arr[0].length - 1), '*');
            let d= arr[0].split('');
            let length = d.length;
            d[length-1]='*';
            arr[0] = d.join('');
        } else {
            arr[1] = arr[1].replace(arr[1].charAt(0), '*');
        }
        return arr.join('.');
    },
    addMointor() {
      this.$clickMonitor.update(reduce(document.querySelectorAll('.mask-centercont'), (arr, el) => {
        const callback = function (params) {
          const buttonId = `return-block-module-${params.monitor.status}`;
            return {
              buttonId,
              ...store.getClickMonitorParams()
            };
				};
				arr.push({el, event: 'expose', callback});
				return arr;
      }, []));
    }
  },
  computed: {
    mobile: {
        get() {
            return store.form.mobile;
        },
        set(val) {
            store.form.mobile = val;
        }
    },
    lowerPrice() {
      return store.price.lower.lastMonthDealPrice;
    },
    normalPrice() {
      return store.price.normal.price;
    },
    isShowSuccessCoupon() {
      return store.isShowSuccessCoupon;
    },
    seriesName() {
      return store.form.series.name;
    },
    recommendSeriesFixedItems() {
      return store.recommendSeriesFixedItems;
    },
    couponValue() {
        return store.couponValue;
    },
    priceForH5() {
        // 有限展示上月成交价, 如果没有展示厂商指导价
        return store.returnBlockMainPrice.lower.lastMonthDealPriceFormat || (store.returnBlockMainPrice.normal.price ? this.hidden(this.format(store.returnBlockMainPrice.normal.price, 2)) + '万元' : '暂无价格');
    },
    returnBlockArr() {
      return store.returnBlockArr;
    },
    returnBlockShow: {
        get() {
            return store.returnBlockShow;
        },
        set(val) {
            store.returnBlockShow = val;
        }
    }
  },
  components: {
    modal,
    returnReco,
    statement,
    labelInput
  },
  mounted() {
    this.checkInputVisiblity();
  }
};
</script>

<template>
  <section ref="modalReturn"
      class="maskcont"
      id="returnDelayBox"
      v-show="returnBlockShow"
      data-role-side='{"container": ".wrapper", "target": "js-maskbottom-02", "open": "slide-bottom-in", "close": "slide-bottom-out", "delay": "true", "name": "JS_maskbottom_02"}' 
  >
    <div class="maskcont-center mask-centercont">
        <div class="maskcont-center-inner">
            <div class="return-block-container">
              <div class="return-block-inner">
                  <div class="header">
                    <img src="../../../assets/return_banner.png"/>
                  </div>
                  <div class="main-series">
                    <div class="car-name">{{mainSeries.name}}</div>
                    <div class="car-price">车主真实成交价<span>{{priceForH5}}</span></div>
                    <div class="car-img">
                      <img :src="mainSeries.image" />
                    </div>
                    <label-input v-if="!inputCookie" ref="mobile" :params="mobileConf" v-model="mobile"></label-input>
                    <return-reco></return-reco>
                    <div class="submit-btn" @click="submit">免费获取真实成交价</div>
                    <statement></statement>
                  </div>
              </div>
              <i class="close" @click="hide"></i>
            </div>
        </div>
    </div>
  </section>
</template>

<style lang="stylus" scoped>
#returnDelayBox
  overflow-scrolling: touch;
  .mask-centercont {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.69);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    z-index: 99;
  }
  .maskcont-center-inner {
    width: 100%;
  }

.return-block-container
    display flex
    justify-content center
    align-items center
    width 100%
    height 100%
    position relative
    .return-block-inner
        width 17rem
        max-height 80%
        overflow-y scroll
        background-color #fff
        margin-top -1rem
        .header
          img
            width 100%
        .main-series
          margin-left .75rem
          margin-right .75rem
          .car-name
            margin-top .5rem
            font-size 1rem
            line-height 1.4rem
            color #333
          .car-price
            font-size .6rem
            line-height .9rem
            color #333
            span
              color #FF6600
              font-size 1.35rem
              line-height 1.55rem
          .car-img
            text-align center
            img
              width 7.25rem
          .submit-btn
            width 15.25rem
            height 2.1rem
            background linear-gradient(128deg, #FF9800 0%, #E61900 100%)
            border-radius .25rem
            text-align center
            color #fff
            font-size .7rem
            line-height 2.1rem

    .close
        position absolute
        width 2rem
        height 2rem
        bottom -2.5rem
        left 50%
        transform translateX(-50%)
        background url('../../../assets/return_close.png') center center  no-repeat
        background-size cover
</style>
